import { useEffect, useState } from "react";
import { Megaphone } from "lucide-react";
import { api, resolveFileUrl } from "@/lib/api";
import { PageMasthead } from "@/components/ui-custom/PageMasthead";
import { RevealStagger, staggerItem } from "@/components/ui-custom/RevealOnScroll";
import { motion } from "framer-motion";

export default function Berita() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/public/announcements").then((r) => setItems(r.data)).finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="berita-page">
      <PageMasthead breadcrumb="BERITA" title="Berita Industri" subtitle="Maklumat & pengumuman terkini PPPS." />

      <section className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        {loading ? (
          <div className="text-center py-16 text-piks-muted">Memuatkan...</div>
        ) : items.length === 0 ? (
          <div className="text-center py-16 text-piks-muted" data-testid="berita-empty-state">
            <Megaphone className="w-10 h-10 mx-auto mb-3 opacity-40" />
            Tiada pengumuman tersedia.
          </div>
        ) : (
          <RevealStagger className="space-y-5" staggerDelay={0.08}>
            {items.map((a) => (
              <motion.div key={a.id} variants={staggerItem} className="rounded-xl bg-white border border-piks-border hover:border-piks-gold/40 transition-colors overflow-hidden" data-testid={`berita-item-${a.id}`}>
                {a.image_url && (
                  <div className="w-full h-56 overflow-hidden">
                    <img src={resolveFileUrl(a.image_url)} alt={a.title} className="w-full h-full object-cover" data-testid={`berita-item-image-${a.id}`} />
                  </div>
                )}
                <div className="p-6">
                  <p className="text-xs text-piks-muted mb-2">{new Date(a.published_at).toLocaleDateString("ms-MY", { day: "2-digit", month: "long", year: "numeric" })}</p>
                  <h3 className="font-display text-lg font-bold text-piks-black mb-2">{a.title}</h3>
                  <p className="text-sm text-piks-muted leading-relaxed">{a.body}</p>
                </div>
              </motion.div>
            ))}
          </RevealStagger>
        )}
      </section>
    </div>
  );
}
